import { Currency } from 'server/types';
import * as fmt from 'shared/payments/fmt';

type Props = {
  subtotal?: number;
  taxAmount?: number;
  total?: number;
  currency: Currency;
  isLoading: boolean;
};

export function TaxBreakdown({ subtotal, taxAmount, total, currency, isLoading }: Props) {
  if (isLoading) {
    return (
      <div class="flex items-center gap-2 pt-3 pb-1 text-sm text-gray-400">
        <div
          class="animate-spin"
          style="width:14px;height:14px;border:2px solid #e2e8f0;border-top-color:var(--m-primary, #003da6);border-radius:50%"
        />
        Calculating tax...
      </div>
    );
  }

  if (!taxAmount || !subtotal || !total) {
    return null;
  }

  function fmtAmount(cents: number) {
    return fmt.price({ priceInCents: cents, currency });
  }

  return (
    <div class="pt-3 pb-1">
      <div class="flex justify-between py-1">
        <span class="text-sm text-gray-500">Subtotal</span>
        <span class="text-sm text-gray-700 tabular-nums">{fmtAmount(subtotal)}</span>
      </div>
      <div class="flex justify-between py-1">
        <span class="text-sm text-gray-500">Tax</span>
        <span class="text-sm text-gray-700 tabular-nums">{fmtAmount(taxAmount)}</span>
      </div>
      <hr class="my-1.5 border-gray-200" />
      <div class="flex justify-between py-1">
        <span class="text-sm font-semibold text-gray-900">You'll be charged</span>
        <span class="text-base font-bold tabular-nums" style="color:var(--m-primary, #003da6)">
          {fmtAmount(total)}
        </span>
      </div>
    </div>
  );
}
